import { hexWithAlpha } from '../../../timeline/components/cross-team-colors';
import { TrackRow } from '../../../timeline/types';
import { getEffectiveTrackColor } from '../../../timeline/utils';

export function resolveTrackEventColors(
  track: TrackRow,
  tracksById: Map<string, TrackRow>,
  fallbackPrimary: string,
  fallbackBackground: string,
): { primaryColor: string; backgroundColor: string } {
  const effectiveColor = getEffectiveTrackColor(track, tracksById);
  return {
    primaryColor: effectiveColor ?? fallbackPrimary,
    backgroundColor: effectiveColor
      ? hexWithAlpha(effectiveColor, 0.15)
      : fallbackBackground,
  };
}
